export default __webpack_public_path__ + "static/media/034-plane.c8d031cf.svg";